import './app';
// Templates
import "./templates/blog";
import "./templates/collections";
import "./templates/password";
import "./templates/product";
// Components
import "./components/payment-delivery-icons";
import "./components/main-account";
import "./components/megamenu";
import "./components/quick-buy";
import './utils/product-card-color-thumbs';
//Sections
import "./sections/announcement";
import "./sections/cart-drawer";
import "./sections/main-register";
